"use strict";

require("../../style/default.less");
require("./index.less");
require("../../tooltip/style");